var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBuildings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 275.677,
    height: 242.351,
    viewBox: "0 0 275.677 242.351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.08;}.b{fill:#707070;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-1127.221 -30.918)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1138.6 30.918)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.404)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1151.679,103.575l5.4,5.4v33.746l-14.238,14.231v99.322H1184.5V30.968l-32.818,18.769Zm12.369,128.282-9.5,9.5v-52.5l9.5-9.5Zm15.317-80.408-8.275,8.274V104.648l8.275-8.274Zm-16.549-89.137,8.275-8.274V77.757l-8.275,8.274Z",
    transform: "translate(-1142.846 -30.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1177.386,110.774V43.59l-26.637-12.672V256.533h40.534V124.677Z",
    transform: "translate(-1102.807 -30.918)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1177.628,40.045V73.5l-17.676,17.677V210.293H1190.4V149.37l8.827,8.82v52.1h16.658V155.437l9.816-9.821V69.29Zm1.96,135.8-8.826-8.826v-54.05l8.826,8.82Zm25.812-43.464-8.826-8.826V69.5l8.826,8.82Z",
    transform: "translate(-972.779 15.321)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1173.148,80.363,1184.51,69V40.535l-27.163,16.526,15.746,15.746Z",
    transform: "translate(-985.976 17.806)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1129.1,71.2v45.855l8.074,8.074v27.486l-7.511,7.51v31.848h23.763V155.346l7.115-7.116v43.743h13.4V43.661Zm37.561,22.014-27.8,17.076V82.843l27.8-17.076Z",
    transform: "translate(-1129.097 33.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1154.431,87.974l14.454-14.454V62.939L1137.5,43.661V191.978h16.933Z",
    transform: "translate(-1086.533 33.639)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1127.221,77.871l8.384-8.384h259.02l8.273,8.274Z",
    transform: "translate(0 195.398)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuildings);
export default __webpack_public_path__ + "static/media/icon_buildings.061b5e3ebc5827875da2c33ce48b3973.svg";
export { ForwardRef as ReactComponent };